module.exports = __webpack_public_path__ + "img/banner.e2d45b76.png";